"use strict";

(function () {
  'use strict';

  function DateService(Moment) {
    var isDate = function isDate(s) {
      var date = new Date(s);
      return date instanceof Date && !isNaN(date.valueOf());
    };

    var isDateObj = function isDateObj(date) {
      return date instanceof Date;
    };

    var formatSlashesToDashes = function formatSlashesToDashes(dateStr) {
      var pieces = dateStr.split('/');

      if (pieces.length === 3 && pieces[2].length === 4) {
        var year = pieces[2];
        var day = pieces[1];
        var month = pieces[0];
        pieces = [year, month, day];
      }

      if (pieces[1].length === 1) {
        pieces[1] = '0' + pieces[1];
      }

      if (pieces[2].length === 1) {
        pieces[2] = '0' + pieces[2];
      }

      return pieces.join('-');
    };

    return {
      isDate: isDate,
      isDateObj: isDateObj,
      formatSlashesToDashes: formatSlashesToDashes
    };
  }

  DateService.$inject = ['Moment'];
  angular.module('date-service', []).service('DateService', DateService);
})();